const MerchantsRequestsList = () =>
  import('../screens/MerchantsRequests/List/MerchantsRequestsList.vue');

export default [
  {
    children: [
      {
        component: MerchantsRequestsList,
        meta: {
          pageTitle: 'Merchants Requests',
        },
        name: 'merchants-requests',
        path: '',
      },
    ],
    meta: {
      activeSidebarItemId: 'merchants-requests',
      authority: 'pending_reviews:view',
    },
    path: '/merchants-requests',
  },
];
